const tableFields = [
    {
        key: 'number',
        label: 'NUMBER',
        thClass: 'min-width-88',
        disableSort: true
    },
    {
        key: 'documentStatus',
        label: 'DOCUMENT STATUS',
        thClass: 'min-width-160'
    },
    {
        key: 'documentType',
        label: 'DOCUMENT TYPE',
        thClass: 'min-width-143'
    },
    {
        key: 'materialDocument',
        label: 'MATERIAL DOCUMENT',
        thClass: 'min-width-143'
    },
    {
        key: 'materialDocumentItem',
        label: 'MATERIAL DOCUMENT ITEM',
        thClass: 'min-width-143'
    },
    {
        key: 'bSpaceMatDoc',
        label: 'BSPACE NUMBER',
        thClass: 'min-width-143'
    },
    {
        key: 'bSpaceMatDocReversal',
        label: 'BSPACE NUMBER REVERSAL',
        thClass: 'min-width-143'
    },
    {
        key: 'materialDocumentReversal',
        label: 'MATERIAL DOCUMENT REVERSAL',
        thClass: 'min-width-143'
    },
    {
        key: 'materialDocumentItemReversal',
        label: 'MATERIAL DOCUMENT ITEM REVERSAL',
        thClass: 'min-width-143'
    },
    {
        key: 'isCanceled',
        label: 'Reversed',
        thClass: 'min-width-143'
    },
    {
        key: 'documentDate',
        label: 'DOCUMENT DATE',
        thClass: 'min-width-143'
    },
    {
        key: 'postingDate',
        label: 'POSTING DATE',
        thClass: 'min-width-143'
    },
    {
        key: 'plantDisplay',
        label: 'PLANT',
        thClass: 'min-width-148'
    },
    {
        key: 'docHeaderText',
        label: 'DOCUMENT HEADER TEXT',
        thClass: 'min-width-143'
    },
    {
        key: 'deliveryNote',
        label: 'DELIVERY NOTES',
        thClass: 'min-width-143'
    },
    {
        key: 'materialSlip',
        label: 'MATERIAL SLIP',
        thClass: 'min-width-143'
    },
    {
        key: 'material',
        label: 'MATERIAL',
        thClass: 'min-width-143'
    },
    {
        key: 'materialDesc',
        label: 'MATERIAL DESCRIPTION',
        thClass: 'min-width-252'
    },
    {
        key: 'baseSku',
        label: 'UNIT OF ENTRY',
        thClass: 'min-width-143'
    },
    {
        key: 'qty',
        label: 'QUANTITY IN UNIT OF ENTRY',
        thClass: 'min-width-143'
    },
    {
        key: 'vendorDisplay',
        label: 'VENDOR',
        thClass: 'min-width-282'
    },
    {
        key: 'poNumber',
        label: 'PO NUMBER',
        thClass: 'min-width-143'
    },
    {
        key: 'movementType',
        label: 'MOVEMENT TYPE',
        thClass: 'min-width-143'
    },
    {
        key: 'specialStock',
        label: 'SPECIAL STOCK',
        thClass: 'min-width-143'
    },
    {
        key: 'valType',
        label: 'VALUATION TYPE',
        thClass: 'min-width-143'
    },
    {
        key: 'slocCode',
        label: 'STORAGE LOCATION',
        thClass: 'min-width-143'
    },
    {
        key: 'goodsRecipient',
        label: 'GOODS RECEPIENT',
        thClass: 'min-width-143'
    },
    {
        key: 'unloadingPoint',
        label: 'UNLOADING POINT',
        thClass: 'min-width-143'
    },
    {
        key: 'reasonMovementDisplay',
        label: 'REASON FOR MOVEMENT',
        thClass: 'min-width-143'
    },
    {
        key: 'costCenter',
        label: 'COST CENTER',
        thClass: 'min-width-143'
    },
    {
        key: 'order',
        label: 'ORDER',
        thClass: 'min-width-143'
    },
    {
        key: 'asset',
        label: 'ASSET',
        thClass: 'min-width-143'
    },
    {
        key: 'wbsElement',
        label: 'WBS ELEMENT',
        thClass: 'min-width-143'
    },
    {
        key: 'createdBy',
        label: 'CREATED BY',
        thClass: 'min-width-143'
    },
    {
        key: 'createdTime',
        label: 'CREATED TIME',
        thClass: 'min-width-143'
    },
    {
        key: 'action',
        label: 'ACTION',
        thClass: 'min-width-113',
        tdClass: 'min-width-113',
        disableSort: true
    }
];
const tableFieldsTp = [
    {
        key: 'line',
        label: 'NUMBER',
        thClass: 'grid__width-88',
        tdClass: 'grid__width-88',
        disableSort: true
    },
    {
        key: 'documentStatusCode',
        label: 'DOCUMENT STATUS',
        thClass: 'grid__width-227'
    },
    {
        key: 'documentType',
        label: 'DOCUMENT TYPE',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocument',
        label: 'MATERIAL DOCUMENT',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocumentItem',
        label: 'MATERIAL DOCUMENT ITEM',
        thClass: 'grid__width-227'
    },
    {
        key: 'bSpaceMatDoc',
        label: 'BSPACE NUMBER',
        thClass: 'grid__width-227'
    },
    {
        key: 'bSpaceMatDocReversal',
        label: 'BSPACE NUMBER REVERSAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocumentReversal',
        label: 'MATERIAL DOCUMENT REVERSAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocumentItemReversal',
        label: 'MATERIAL DOCUMENT ITEM REVERSAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'isCanceledDisplay',
        label: 'REVERSED',
        thClass: 'grid__width-227'
    },
    {
        key: 'documentDate',
        label: 'DOCUMENT DATE',
        thClass: 'grid__width-227'
    },
    {
        key: 'postingDate',
        label: 'POSTING DATE',
        thClass: 'grid__width-227'
    },
    {
        key: 'plantDisplay',
        label: 'PLANT',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialSlip',
        label: 'MATERIAL SLIP',
        thClass: 'grid__width-227'
    },
    {
        key: 'docHeaderText',
        label: 'DOCUMENT HEADER TEXT',
        thClass: 'grid__width-227'
    },
    {
        key: 'material',
        label: 'MATERIAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDesc',
        label: 'MATERIAL DESCRIPTION',
        thClass: 'grid__width-227'
    },
    {
        key: 'baseUOM',
        label: 'UNIT OF ENTRY',
        thClass: 'grid__width-227'
    },
    {
        key: 'qty',
        label: 'QUANTITY IN UNIT OF ENTRY',
        thClass: 'grid__width-227'
    },
    {
        key: 'movementType',
        label: 'MOVEMENT TYPE',
        thClass: 'grid__width-227'
    },
    {
        key: 'sLocCode',
        label: 'STORAGE LOCATION',
        thClass: 'grid__width-227'
    },
    {
        key: 'valType',
        label: 'VALUATION TYPE',
        thClass: 'grid__width-227'
    },
    {
        key: 'specialStock',
        label: 'SPECIAL STOCK',
        thClass: 'grid__width-227'
    },
    {
        key: 'vendorDisplay',
        label: 'VENDOR',
        thClass: 'grid__width-227'
    },
    {
        key: 'slocCodeStockTransfer',
        label: 'SLOC STOCK TRANSFER',
        thClass: 'grid__width-227'
    },
    {
        key: 'specialStockNameStockTransfer',
        label: 'SPECIAL STOCK TRANSFER',
        thClass: 'grid__width-227'
    },
    {
        key: 'vendorStockTransferDisplay',
        label: 'VENDOR STOCK TRANSFER',
        thClass: 'grid__width-227'
    },
    {
        key: 'goodsRecipient',
        label: 'GOODS RECEPIENT',
        thClass: 'grid__width-227'
    },
    {
        key: 'unloadingPoint',
        label: 'UNLOADING POINT',
        thClass: 'grid__width-227'
    },
    {
        key: 'reasonMovementDisplay',
        label: 'REASON FOR MOVEMENT',
        thClass: 'grid__width-227'
    },
    {
        key: 'createdBy',
        label: 'CREATED BY',
        thClass: 'grid__width-227'
    },
    {
        key: 'createdTime',
        label: 'CREATED TIME',
        thClass: 'grid__width-227'
    },
    {
        key: 'action',
        label: 'ACTION',
        thClass: 'grid__width-113',
        tdClass: 'grid__width-113',
        disableSort: true
    }
];
const tableFieldsGi = [
    {
        key: 'line',
        label: 'NUMBER',
        thClass: 'grid__width-88',
        tdClass: 'grid__width-88',
        disableSort: true
    },
    {
        key: 'documentStatusCode',
        label: 'DOCUMENT STATUS',
        thClass: 'grid__width-227'
    },
    {
        key: 'documentType',
        label: 'DOCUMENT TYPE',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocument',
        label: 'MATERIAL DOCUMENT',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocumentItem',
        label: 'MATERIAL DOCUMENT ITEM',
        thClass: 'grid__width-227'
    },
    {
        key: 'bSpaceMatDoc',
        label: 'BSPACE NUMBER',
        thClass: 'grid__width-227'
    },
    {
        key: 'bSpaceMatDocReversal',
        label: 'BSPACE NUMBER REVERSAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocumentReversal',
        label: 'MATERIAL DOCUMENT REVERSAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDocumentItemReversal',
        label: 'MATERIAL DOCUMENT ITEM REVERSAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'isCanceledDisplay',
        label: 'REVERSED',
        thClass: 'grid__width-227'
    },
    {
        key: 'documentDate',
        label: 'DOCUMENT DATE',
        thClass: 'grid__width-227'
    },
    {
        key: 'postingDate',
        label: 'POSTING DATE',
        thClass: 'grid__width-227'
    },
    {
        key: 'plantDisplay',
        label: 'PLANT',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialSlip',
        label: 'MATERIAL SLIP',
        thClass: 'grid__width-227'
    },
    {
        key: 'docHeaderText',
        label: 'DOCUMENT HEADER TEXT',
        thClass: 'grid__width-227'
    },
    {
        key: 'material',
        label: 'MATERIAL',
        thClass: 'grid__width-227'
    },
    {
        key: 'materialDesc',
        label: 'MATERIAL DESCRIPTION',
        thClass: 'grid__width-227'
    },
    {
        key: 'baseUOM',
        label: 'UNIT OF ENTRY',
        thClass: 'grid__width-227'
    },
    {
        key: 'qty',
        label: 'QUANTITY IN UNIT OF ENTRY',
        thClass: 'grid__width-227'
    },
    {
        key: 'poNumber',
        label: 'PO NUMBER',
        thClass: 'grid__width-227'
    },
    {
        key: 'orderNumber',
        label: 'ORDER NUMBER',
        thClass: 'grid__width-227'
    },
    {
        key: 'reservationNumber',
        label: 'RESERVATION NUMBER',
        thClass: 'grid__width-227'
    },
    {
        key: 'movementType',
        label: 'MOVEMENT TYPE',
        thClass: 'grid__width-227'
    },
    {
        key: 'specialStock',
        label: 'SPECIAL STOCK',
        thClass: 'grid__width-227'
    },
    {
        key: 'valType',
        label: 'VALUATION TYPE',
        thClass: 'grid__width-227'
    },
    {
        key: 'sLocCode',
        label: 'STORAGE LOCATION',
        thClass: 'grid__width-227'
    },
    {
        key: 'goodsRecipient',
        label: 'GOODS RECEPIENT',
        thClass: 'grid__width-227'
    },
    {
        key: 'unloadingPoint',
        label: 'UNLOADING POINT',
        thClass: 'grid__width-227'
    },
    {
        key: 'reasonMovementDisplay',
        label: 'REASON FOR MOVEMENT',
        thClass: 'grid__width-227'
    },
    {
        key: 'costCenter',
        label: 'COST CENTER',
        thClass: 'grid__width-227'
    },
    {
        key: 'createdBy',
        label: 'CREATED BY',
        thClass: 'grid__width-227'
    },
    {
        key: 'createdTime',
        label: 'CREATED TIME',
        thClass: 'grid__width-227'
    },
    {
        key: 'action',
        label: 'ACTION',
        thClass: 'grid__width-113',
        tdClass: 'grid__width-113',
        disableSort: true
    }
];
var Actions;
(function (Actions) {
    Actions["GET_GR_LIST"] = "getGrList";
    Actions["GET_GI_LIST"] = "getGiList";
    Actions["GET_TP_LIST"] = "getTpList";
    Actions["DOWNLOAD_EXCEL_GR_LIST"] = "downloadExcelGrList";
    Actions["DOWNLOAD_EXCEL_GI_LIST"] = "downloadExcelGiList";
    Actions["DOWNLOAD_EXCEL_TP_LIST"] = "downloadExcelTpList";
    Actions["GET_RANGE_DATE"] = "getRangeDateTlistMigo";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_GR_LIST"] = "setGrList";
    Mutations["SET_GI_LIST"] = "setGiList";
    Mutations["SET_TP_LIST"] = "setTpList";
    Mutations["SET_FILTER_POPUP"] = "setFilterTransactionListGr";
    Mutations["SET_FILTER_POPUP_GI"] = "setFilterTransactionListGi";
    Mutations["SET_FILTER_POPUP_TP"] = "setFilterTransactionListTp";
    Mutations["SET_FILTER_TIPS_GR"] = "setGrFilterTips";
    Mutations["SET_FILTER_TIPS_GI"] = "setGrFilterTipsGi";
    Mutations["SET_FILTER_TIPS_TP"] = "setGrFilterTipsTp";
    Mutations["SET_DELETE_TIPS_GR"] = "setDeleteTipsGr";
    Mutations["SET_DELETE_TIPS_GI"] = "setDeleteTipsGi";
    Mutations["SET_DELETE_TIPS_TP"] = "setDeleteTipsTp";
    Mutations["SET_LOOKUPS_FILTER_GR"] = "setLookupsFilterGr";
    Mutations["SET_LOOKUPS_FILTER_GI"] = "setLookupsFilterGi";
    Mutations["SET_LOOKUPS_FILTER_TP"] = "setLookupsFilterTp";
    Mutations["SET_NOT_FOUND"] = "setListNotFoundMigo";
    Mutations["SET_NOT_FOUND_GI"] = "setListNotFoundMigoGi";
    Mutations["SET_NOT_FOUND_TP"] = "setListNotFoundMigoTp";
    Mutations["SET_IS_ALREADY_RENDER_GR"] = "setIsAlreadyRenderGr";
    Mutations["SET_IS_ALREADY_RENDER_GI"] = "setIsAlreadyRenderGi";
    Mutations["SET_IS_ALREADY_RENDER_TP"] = "setIsAlreadyRenderTp";
    Mutations["SET_RESET_GR"] = "setResetGr";
    Mutations["SET_RESET_GI"] = "setResetGi";
    Mutations["SET_RESET_TP"] = "setResetTp";
    Mutations["SET_TABLE_PAYLOAD_GR"] = "setTablePayloadGr";
    Mutations["SET_TABLE_PAYLOAD_GI"] = "setTablePayloadGi";
    Mutations["SET_TABLE_PAYLOAD_TP"] = "setTablePayloadTp";
    Mutations["SET_RANGE_DATE_GR"] = "setRangeDateGr";
    Mutations["SET_RANGE_DATE_GI"] = "setRangeDateGi";
    Mutations["SET_RANGE_DATE_TP"] = "setRangeDateTp";
    Mutations["SET_GR_TEMP_FILTER_VAL"] = "setTempGrMigoFilterVal";
    Mutations["SET_GI_TEMP_FILTER_VAL"] = "setTempGiMigoFilterVal";
    Mutations["SET_TP_TEMP_FILTER_VAL"] = "setTempTpMigoFilterVal";
    Mutations["SET_RESET_GI_FORM_FILTER"] = "setResetGiFormFilter";
    Mutations["SET_RESET_TP_FORM_FILTER"] = "setResetTpFormFilter";
    Mutations["SET_DEFAULT_DATE_FILTER"] = "setDefaultDateFilterMigo";
    Mutations["SET_RESET"] = "resetTlistMigo";
    Mutations["SET_REFRESH_STATE"] = "setRefreshStateMigo";
})(Mutations || (Mutations = {}));
export { Actions, Mutations, tableFields, tableFieldsGi, tableFieldsTp };
